import { render, staticRenderFns } from "./SharedContentType.vue?vue&type=template&id=c7164c74&"
import script from "./SharedContentType.vue?vue&type=script&lang=js&"
export * from "./SharedContentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports